/** Публічний каталог Rozetka визначається продавцем, а не доступом до кабінету. */
export interface CatalogStore {
  marketplace: { slug: string }
  merchant_id: string
  url: string
  has_public_seller_identity: boolean
}

/** Каталог магазину і його оновлення: сервер синхронізує обидва маркетплейси без вимоги до токена. */
export function hasStoreCatalog(store: CatalogStore): boolean {
  if (!store.url) return false
  if (store.marketplace?.slug === 'rozetka') return store.has_public_seller_identity === true
  return store.marketplace?.slug === 'prom' && Boolean(store.merchant_id)
}

/**
 * Підключений Rozetka-магазин, зокрема той, чий продавець ще перевіряється.
 * `merchant_id` тут лише ознака підключення за токеном, ніколи не ідентичність продавця.
 */
export function isConnectedRozetkaStore(store: CatalogStore): boolean {
  if (store.marketplace?.slug !== 'rozetka' || !store.url) return false
  return store.has_public_seller_identity === true || Boolean(store.merchant_id)
}

/** Додавання товарів і конкурентів сервер дозволяє за підтвердженим продавцем, без вимоги до токена. */
export function hasVerifiedSellerStore(stores: Pick<CatalogStore, 'has_public_seller_identity'>[]): boolean {
  return stores.some((store) => store.has_public_seller_identity === true)
}
